module.exports = __webpack_public_path__ + "img/r_hone_illustration04.0834342e.png";